import React from 'react';
import CountryDropDown from "../../components/user/CountryDropDown";

export default function LocationControls({
  radius, 
  setRadius,
  location,
  locationError,
  isLocating,
  getCurrentLocation
}) {
  const radiusOptions = [
    { value: 1000, label: '1 km' },
    { value: 5000, label: '5 km' },
    { value: 10000, label: '10 km' },
    { value: 20000, label: '20 km' },
    { value: 50000, label: '50 km' },
    { value: 100000, label: '100 km' },
    { value: 200000, label: '200 km' },
  ];
  {/*
    async populateCountries() {
    const { data: countries } = await http.get(apiUrl + "/countries");
    this.setState({ countries: countries });
    //this.selectCountries = this.state.countries.map((country)=>({label: country.name, value: country.name}) );
    this.selectCountries = this.state.countries.map((country) => ({
      _id: country._id,
      label: country.name,
      value: country.name,
    }));
  }
*/}
  return (
    <div className="bg-gray-50 rounded-lg p-4 mb-6">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex-1 min-w-[250px]">
          <div className="flex items-center">
            <h3 className="text-lg font-medium text-gray-700 mr-3">
              Search Location
            </h3>
            
            <button
              onClick={getCurrentLocation}
              disabled={isLocating}
              className="flex items-center text-blue-600 hover:text-blue-800 disabled:opacity-50"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
              </svg>
              {isLocating ? 'Locating...' : 'Use Current Location'}
            </button>
          </div>
          
          {locationError && (
            <p className="text-red-500 text-sm mt-1">{locationError}</p>
          )}
          
          <div className="mt-2 text-sm text-gray-600">
            {location.isDefault ? (
              <span>Using default location</span>
            ) : (
              <span>
                Current: {location.lat.toFixed(4)}, {location.lng.toFixed(4)}
              </span>
            )}
          </div>
        </div>
        
        <div className="flex-1 min-w-[200px]">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Search Radius
          </label>
          <select
            value={radius}
            onChange={(e) => setRadius(Number(e.target.value))}
            className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          >
            {radiusOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}
